import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Homepage/BusinessTravel/BusinessTravel.css";
import "./OnDemand.css";
import Heading from "../../../utls/Heading";

const OnDemand = () => {
  return (
    <>
      <div className="business-travel-section container  mb-md-5 mt-lg-4 mt-xxl-5 mt-5 pt-md-3">
        <div className="row ">
          <div className="col-md-12 ">
            <Heading className="text-center customheadings">
              <span>On-Demand</span> Webinars
            </Heading>
          </div>
          <div className="row px-lg-5 mlTab ondemandmlTab">
            <div className="col-lg-4 col-md-4 col-12 mt-md-3 mt-3 d-flex justify-content-center pleft">
              <div className="BT-box shadow h-100">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/demand1.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings h5-font-size">
                      Sustainable Travel Solutions for a Greener Future
                    </h5>
                    <p className="mt-3">
                      Explore actionable strategies for incorporating
                      sustainability into corporate travel programs while
                      maintaining efficiency and cost-effectiveness.
                    </p>
                    <div className="carouselCaption ondemand-btn">
                      <a href="#">
                        <button className="btn bg-transparent text-dark  grotesk-headings fw-bold text-uppercase">
                          Watch Now
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-3 mt-3  d-flex justify-content-center pleft">
              <div className="BT-box shadow h-100">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/demand2.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings h5-font-size">
                      Navigating Post-Pandemic Travel Challenges
                    </h5>
                    <p className="mt-3">
                      Learn how businesses have adapted to the evolving travel
                      landscape with best practices for managing restrictions
                      and traveler safety.
                    </p>
                    <div className="carouselCaption ondemand-btn pt-lg-2">
                      <a href="#">
                        <button className="btn bg-transparent text-dark  grotesk-headings fw-bold text-uppercase">
                          Watch Now
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-3 mt-3  d-flex justify-content-center pleft">
              <div className="BT-box shadow h-100">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/demand3.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings h5-font-size">
                      Leveraging Data for Smarter Travel Decisions
                    </h5>
                    <p className=" mt-3">
                      A deep dive into the role of analytics in crafting
                      cost-effective, efficient, and traveler-friendly corporate
                      travel programs.
                    </p>
                    <div className="carouselCaption ondemand-btn pt-lg-2">
                      <a href="#">
                        <button className="btn bg-transparent text-dark   grotesk-headings fw-bold text-uppercase">
                          Watch Now
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnDemand;
